<template>
  <div>
    <b-card ref="payment" :title="$t('orders.payment_method')">
      <payment-method-choice
        :allowed-methods="allowedMethods"
        :selected-method="selectedMethod"
        @change="onMethodChange"
      />
      <b-button
        :disabled="!readyToPay"
        variant="success"
        size="lg"
        @click="pay"
      >
        {{ payActionText }}
      </b-button>
      <p
        class="text-muted mt-2 font-size-sm"
        v-text="$t('orders.payment_error_note')"
      />
    </b-card>
  </div>
</template>

<script>
import PaymentMethodChoice from './PaymentMethodChoice'

export default {
  name: 'PaymentForm',
  components: { PaymentMethodChoice },
  props: {
    allowedMethods: {
      type: Array,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    cashActionLabel: {
      type: String,
      default() {
        return this.$t('general.save')
      },
    },
    currencyLabel: {
      type: String,
      required: true,
    },
    payApi: {
      type: Function,
      required: true,
    },
    selectedMethod: {
      type: String,
      required: true,
    },
  },
  emits: ['methodChanged', 'paid'],

  data() {
    return {
      paymentMethod: null,
      paymentPayload: {},
      paymentInProgress: false,
    }
  },

  computed: {
    isBancontact() {
      return this.paymentMethod === 'bancontact'
    },
    isCash() {
      return this.paymentMethod === 'cash'
    },
    payActionText() {
      if (this.isCash) {
        return this.cashActionLabel
      }

      return `${this.$t('general.pay')} ${this.totalAmountLabel}`
    },
    readyToPay() {
      if (this.paymentInProgress) {
        return false
      }

      if (this.isBancontact || this.isCash) {
        return true
      }

      // has selected any card
      return !!this.paymentPayload.cardId
    },
    totalAmountLabel() {
      return this.$options.filters.currency(this.amount, this.currencyLabel)
    },
  },

  mounted() {
    this.paymentMethod = this.selectedMethod
  },

  methods: {
    onMethodChange({ method, payload }) {
      this.paymentMethod = method
      this.paymentPayload = payload
      this.$emit('methodChanged', method)
    },

    pay() {
      this.paymentInProgress = true
      const promise = this.payApi(this.paymentMethod, {
        card_id: this.paymentPayload.cardId,
        ...this.paymentPayload,
      })
      this.$uiBlocker(promise, this.$refs.payment)
      promise
        .then(result => {
          if (result) {
            this.$toast.success(result.message)
          }
        })
        .then(() => {
          this.$emit('paid', this.paymentMethod)
        })
        .catch(error => {
          this.$emit('error', error.message)
        })
        .finally(() => {
          this.paymentInProgress = false
        })
    },
  },
}
</script>
